<template>
  <div>
    <gmap-map
      :center="locationData.position"
      :zoom="15"
      map-type-id="terrain"
      style="width: 100%; height: 300px"
      class="shops-google-map"
    >
      <gmap-marker
        :position="locationData.position"
        :clickable="true"
        :draggable="true"
        @click="center=locationData.position"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  props: ['locationData']
}
</script>



// WEBPACK FOOTER //
// src/components/Shops/GoogleMap.vue